import { faPhone as fasPhone } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import autobind from "autobind-decorator";
import { phoneFormatter, phoneValidator } from "bm-ui-kit";
import React from "react";
import type { FormMaskedInputProps, FormMaskedInputState } from "./FormMaskedInput";
import { FormMaskedInput } from "./FormMaskedInput";

export interface FormPhoneProps extends FormMaskedInputProps {
	hungarianOnly?: boolean;
}

export class FormPhone extends FormMaskedInput<string, FormPhoneProps> {
	public static defaultProps: Partial<FormPhoneProps> = {
		type: "tel",
		prepend: <FontAwesomeIcon icon={fasPhone} />,
		dataList: ["+36 20", "+36 30", "+36 31", "+36 50", "+36 70"],
		maxLength: 17,
	};

	protected shouldFieldRevalidate(prevProps: FormPhoneProps, prevState: FormMaskedInputState<string>): boolean {
		const { hungarianOnly } = this.props;

		return super.shouldFieldRevalidate(prevProps, prevState) || prevProps.hungarianOnly !== hungarianOnly;
	}

	@autobind
	protected format(value: string): string {
		if (!value) {
			return value;
		}

		return phoneFormatter(value);
	}

	@autobind
	protected parse(value: string): string {
		return this.format(value);
	}

	@autobind
	protected handleValidate(value: string, allValues: Record<string, any>): string {
		const { required, hungarianOnly } = this.props;

		if (this.isDisabled()) {
			return undefined;
		}

		if (value) {
			if (!phoneValidator(value)) {
				return "Érvénytelen telefonszám!";
			}

			if (hungarianOnly && !value?.startsWith("+36")) {
				return "Csak magyarországi telefonszám adható meg!";
			}
		} else if (required) {
			return "A telefonszám megadása kötelező!";
		}

		return super.handleValidate(value, allValues);
	}
}
